import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import {
  ProfileService,
  NotificationService,
  CertificateListService,
  NotificationKeys,
  ResponseStatus,
  ProcessStepsModalKeys,
  UserVerificationTypes,
  ALTs,
} from "@core";
import { NzModalService } from "ng-zorro-antd/modal";

@Component({
  selector: "app-user-identification",
  templateUrl: "./user-identification.component.html",
  styleUrls: ["./user-identification.component.less"],
  standalone: false,
})
export class UserIdentificationComponent implements OnInit {
  identificationForm!: FormGroup;
  identificationList: any[] = [];

  verifyIdentity!: boolean;
  showForm: boolean = false;
  loading: boolean = false;
  disableIdentification: boolean = true;
  userInformationVerification: boolean = false;

  processStepsModalKeys = ProcessStepsModalKeys;
  userVerificationTypes = UserVerificationTypes;
  alts = ALTs;

  userInformationWindowStep: number = 0;

  userImage: any;
  IdentificationType!: string;

  constructor(
    private modal: NzModalService,
    private fb: FormBuilder,
    private profileService: ProfileService,
    private certificateService: CertificateListService,
    private notify: NotificationService,
  ) {}

  ngOnInit(): void {
    this.buildidentificationForm();
    this.getUserIdentification();
    this.meansOfIdentificationTypes();
  }

  buildidentificationForm() {
    this.identificationForm = this.fb.group({
      number: [null],
      identification_option: [null],
    });
  }

  checkIfAdditionalDetailsExists(data: any) {
    if (data?.additional_detail) {
      const nin = data?.additional_detail?.verification_data?.nin;
      const bvn = data?.additional_detail?.verification_data?.bvn;
      const internationalPassport =
        data?.additional_detail?.verification_data?.international_passport;
      let identityNumber: any;

      if (nin) {
        identityNumber = nin;
      } else if (bvn) {
        identityNumber = bvn;
      } else if (internationalPassport) {
        identityNumber = bvn;
      } else {
        identityNumber = "";
      }

      this.identificationForm.patchValue({
        number: identityNumber,
        identification_option: data?.additional_detail
          ?.identity_verification_type?.code
          ? data?.additional_detail?.identity_verification_type?.code
          : "",
      });

      this.userImage = data?.additional_detail?.verification_data?.image;
      this.IdentificationType =
        data?.additional_detail?.identity_verification_type?.name;
    }
  }

  getUserIdentification() {
    this.profileService
      .getUser()
      .then((res: any) => {
        if (res?.status == ResponseStatus.FAILED) {
          this.showForm = false;
          this.notify.error("", res?.message, NotificationKeys.PROFILE);
          return;
        }

        this.showForm = true;
        this.getUserStatus(res?.data);
        this.checkIfAdditionalDetailsExists(res?.data);
      })
      .catch((err: any) => {
        this.showForm = false;
        console.warn(err);
      });
  }

  getUserStatus(value: any) {
    if (
      (value?.additional_detail == null ||
        value?.additional_detail?.identity_verified == false) &&
      value?.provisioned_candidates == 0
    ) {
      this.disableIdentification = true;
    } else if (
      value?.additional_detail?.identity_verified == false &&
      value?.provisioned_candidates > 0
    ) {
      this.disableIdentification = false;
      this.verifyIdentity = true;
    } else if (value?.additional_detail?.identity_verified == true) {
      this.disableIdentification = false;
      this.verifyIdentity = false;
    } else {
      this.disableIdentification = false;
      this.verifyIdentity = false;
    }
  }

  meansOfIdentificationTypes() {
    this.certificateService
      .getListOfMeansOfIdentificationTypes()
      .then((res) => {
        this.loading = false;
        if (res?.status === ResponseStatus.FAILED) {
          this.notify.info("", res?.message, NotificationKeys.PROFILE);
          return;
        }
        this.identificationList = res?.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  cancelMeansofIdentificationModal() {
    this.userInformationVerification = false;
  }

  identityVerified() {
    this.userInformationVerification = false;
    this.getUserIdentification();
  }

  onVerify() {
    this.userInformationWindowStep = 2;
    this.userInformationVerification = true;
  }
}
